import { ConditionalFormConfigSchema } from 'features/libra/stepComponents/conditionalForm/api/conditionalFormApi'
import { z } from 'zod'

import { sourceZoneFieldSchema } from './sourceContext'

export const planningPreparationSchema = ConditionalFormConfigSchema.extend({
  workPackStepId: z.string().optional(),
  sourceContext: z
    .object({
      field: z.string(),
      title: z.string(),
      zoneFields: z.array(sourceZoneFieldSchema).default([]),
    })
    .optional(),
  sourceField: z.string(),
  sourceZonesField: z.string(),
  summaryField: z.string(),
  recommendationsField: z.string(),
  sourceDetails: z
    .array(z.object({ field: z.string(), label: z.string() }))
    .default([]),
})

export type PlanningPreparationConfig = z.infer<
  typeof planningPreparationSchema
>
